import { render, staticRenderFns } from "./BtnInserirInvestimento.vue?vue&type=template&id=ffaa45e6&"
import script from "./BtnInserirInvestimento.vue?vue&type=script&lang=js&"
export * from "./BtnInserirInvestimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports